import React from "react";


const Header = () => (
  <div>
        <div id="header" style={{borderColor: '#e7e7e7',backgroundColor: 'rgba(255, 255, 255, 0.96)',borderBottom: '1px solid rgba(0, 0, 0, 0.1)'}}>
            <table style={{ width: "100%" }}>
                <tbody>
                    <tr>
                        <td rowSpan="3" style={{ backgroundImage: "url(images/head_c1r1.png)", width: "572px", height: "103px" }} />
                        <td style={{ backgroundImage: "url(images/head_c2r1.png)", textAlign: "right", paddingRight: "5px", height: "47px" }}>
                            <span>
                                <img src="images/iExit.png" style={{ cursor: "pointer" }} />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ backgroundImage: "url(images/head_c2r2.png)", textAlign: "right", height: "47px" }} />
                    </tr>
                    <tr>
                        <td style={{ backgroundImage: "url(images/head_c2r3.png)", height: "9px" }} />
                    </tr>
                    <tr>
                        <td colSpan="2" style={{ textAlign: "left", height: "39px", backgroundColor: "#FFFFFF" }}>
                            <img src="images/iSystem.png" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
  </div>
);
export default Header;


// WEBPACK FOOTER //
// ./src/layout/header.js